import { combineReducers } from 'redux';
import { createActions, createReducer } from 'reduxsauce';
import mirroringCallrollReducer from './Callroll/redux';
import mirroringCheckinReducer from './Checkin/redux';
import mirroringClassroomReducer from './Classroom/redux';
import mirroringExerciseReducer from './Exercise/redux';
import mirroringExerciseStatReducer from './Exercise/Statistics/redux';
import mirroringFinishReducer from './Finish/redux';
import mirroringLayoutReducer from './Layout/redux';
import mirroringLessonPlanReducer from './LessonPlan/redux';
import mirroringLoginReducer from './Login/redux';
import mirroringPostReducer from './Post/redux';
import mirroringAnnouncementReducer from './Announcement/redux';
import mirroringQuestionnaireReducer from './Questionnaire/redux';
import mirroringWSReducer from './WSAccessLayer/redux';

// Define Action
const { Types, Creators } = createActions({
  swallowIt: null,
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {};
// Define Reducer
const sysReucer = createReducer(INITIAL_STATE, {
  [Types.SWALLOW_IT]: (state = INITIAL_STATE) => state,
});

export default combineReducers({
  sys: sysReucer,
  ws: mirroringWSReducer,
  login: mirroringLoginReducer,
  classroom: mirroringClassroomReducer,
  layout: mirroringLayoutReducer,
  exercise: mirroringExerciseReducer,
  statistics: mirroringExerciseStatReducer,
  checkin: mirroringCheckinReducer,
  finish: mirroringFinishReducer,
  questionnaire: mirroringQuestionnaireReducer,
  callroll: mirroringCallrollReducer,
  post: mirroringPostReducer,
  announcement: mirroringAnnouncementReducer,
  lessonPlan: mirroringLessonPlanReducer,
});
